export class VendorAccountResultDto {
    id: number; // 	NOTE: This is vendor account id
    associationVendorId: number;
    accountNumber: string; // 	NOTE: This is vendor account number
    active: boolean; // NOTE: Indicates if vendor account is active
    description: string;
    draftBankAccount: string; // 	NOTE: Bank account name if EFT is active for vendor account
    eftActive: boolean; // NOTE: Indicates if vendor account is enabled for EFT payments
    hasNotes: boolean; // NOTE: Indicates if vendor account has any previous notes
    allowEdit: boolean; // NOTE: Indicates if vendor account can be edited
}
